
import NavigationDrawer from "./components/core/NavigationDrawer.vue";
import NotificationContainer from "./components/notifications/NotificationContainer.vue";

export default {
  name: "DashboardView",
  data() {
    return {
      items: [
      {
          title: ("Home"),
          icon: "mdi-home-outline",
          link: "/dashboard",
          userTypes: ["admin", "super_admin"],
        },
        {
          title: this.$t("sidebar.structures"),
          icon: "mdi-office-building-outline",
          link: "/structures",
          userTypes: ["admin", "super_admin"],
        },
        {
          title: this.$t("sidebar.userGroups"),
          icon: "mdi-account-group-outline",
          link: "/user-groups",
          userTypes: ["super_admin"],
        },
        {
          title: this.$t("sidebar.nutritionists"),
          icon: "mdi-doctor",
          link: "/nutritionists",
          userTypes: ["super_admin", "admin"],
        },
        {
          title: this.$t("sidebar.evaluations"),
          icon: "mdi-clipboard-text-outline",
          link: "/evaluations",
          userTypes: ["super_admin"],
        },
        {
          title: ("Dashboard"),
          icon: "mdi-view-grid-outline",
          link: "/dashboardusers",
          userTypes: ["employee", "nutritionist"],
        },
        {
          title: this.$t("sidebar.notifications"),
          icon: "mdi-bell-outline",
          link: "/alarm-notifications",
          userTypes: ["employee", "nutritionist"],
        },
        // {
        //   title: this.$t("sidebar.tasks"),
        //   icon: "mdi-checkbox-marked-circle-outline",
        //   link: "/activities",
        //   userTypes: ["employee", "nutritionist"],
        // },
        // {
        //   title: this.$t("sidebar.biaSchedule"),
        //   icon: "mdi-calendar-clock",
        //   link: "/bia-schedule",
        //   userTypes: ["employee", "nutritionist"],
        // },
        {
          title: this.$t("sidebar.patients"),
          icon: "mdi-account-heart-outline",
          link: "/patients",
          userTypes: ["employee", "nutritionist", "admin"],
        },
        // {
        //   title: "Compilazione Schede",
        //   icon: "mdi-clipboard-edit-outline",
        //   link: "/patient-forms-selector",
        //   userTypes: ["employee"],
        //   requiresGroup: "infermiere", // Special flag for group-based access
        // },
        {
          title: this.$t("sidebar.reports"),
          icon: "mdi-chart-bar",
          link: "/reports",
          userTypes: ["employee", "nutritionist", "super_admin", "admin"],
        },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    userType() {
      return this.$store.getters.userType;
    },
  },
  components: {
    NavigationDrawer,
    NotificationContainer,
  },
};
